import React, { FC } from 'react'

import { ArrowRightIcon, IconSizes } from '@inno-ui/icons'
import { useTranslation } from 'react-i18next'

import styles from './FullTourStepFour.module.scss'
import projectsDe from './assets/projects-de.webp'
import projectsEn from './assets/projects-en.webp'

export const FullTourStepFour: FC = () => {
  const { i18n, t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_four'
  })
  const pathChips = t('path_chips', { returnObjects: true }) as string[]
  const projectImage = i18n.language?.startsWith('de') ? projectsDe : projectsEn

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-four-title'
      aria-describedby='full-tour-step-four-description'
    >
      <div className={styles.tourCardContent}>
        <div className={styles.tourMain}>
          <div className={styles.tourLeft}>
            <div className={styles.tourHeading}>
              <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
              <h1 id='full-tour-step-four-title' className={styles.tourTitle}>
                <span>{t('title_before')}</span>
                <span className={styles.titleHighlight}>
                  {t('title_highlighted')}
                </span>
              </h1>
            </div>

            <div className={styles.tourDetails}>
              <nav className={styles.path} aria-label={t('path_label')}>
                {pathChips.map((chip, index) => (
                  <React.Fragment key={chip}>
                    {index > 0 && (
                      <ArrowRightIcon
                        aria-hidden='true'
                        color='var(--white)'
                        size={IconSizes.Size16}
                      />
                    )}
                    <span className={styles.pathChip}>{chip}</span>
                  </React.Fragment>
                ))}
              </nav>

              <div
                id='full-tour-step-four-description'
                className={styles.tourDescription}
              >
                <p>{t('description_first')}</p>
                <p>{t('description_second')}</p>
                <p>{t('description_third')}</p>
              </div>
            </div>
          </div>

          <div className={styles.visualColumn}>
            <div className={styles.visualCard}>
              <img
                src={projectImage}
                alt={t('image_alt')}
                className={styles.projectImage}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
